export default class Bacon {
    constructor() {
        document.addEventListener('click', this.openBeacon.bind(this));
    }

    openBeacon(e) {
        if (!('helpscout' in e.target.dataset)) {
            return;
        }

        e.preventDefault();

        switch (e.target.dataset.helpscout) {
            case 'askQuestion':
                this.askQuestion();
                break;
        }
    }

    askQuestion() {
        window.Beacon('open');
        window.Beacon('navigate', '/ask/message/');
    }
}
